export const reportedContentStatus = [
  { value: '', label: 'Select Status ' },
  { value: 'open', label: 'Open' },
  { value: 'closed', label: 'Closed' },
  { value: 'resolved', label: 'Resolved' }
]
